import { StateCreator } from 'zustand';

import { TopPlayer, userTournamentStatus } from '@/api/tournaments';
import { CommonStoreType, TournamentsState } from '@/store/commonStore/types';

export const useTournamentsSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  TournamentsState
> = (set, get) => {
  return {
    tournaments: [],
    userTournamentsStatuses: [],
    tournamentGameCategories: [],
    tournamentGameIds: [],
    fetchUserTournamentStatus: async () => {
      try {
        const { data: userTournamentsStatuses } = await userTournamentStatus();

        set({ userTournamentsStatuses });
      } catch (error) {
        console.log(error);
      }
    },
    updateUserTournamentStatus: (newTournamentStatus: TopPlayer) => {
      set({
        userTournamentsStatuses: get().userTournamentsStatuses.map(
          (userTournament) =>
            userTournament.tournamentId === newTournamentStatus.tournamentId
              ? newTournamentStatus
              : userTournament
        ),
      });
    },
  };
};
